import Reveal from '@/components/base/Reveal';
import { popularTags } from '@/mocks/home';

export default function TagSection() {
  return (
    <section id="tags" className="w-full bg-background-50 py-20 md:py-24">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14">
          <Reveal>
            <div>
              <div className="flex items-center gap-2 text-[12px] tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-500" />
                04 / 话题导航
              </div>
              <h3 className="mt-3 font-heading text-[30px] font-black tracking-tight text-foreground-950 md:text-[38px]">
                热门标签
              </h3>
              <p className="mt-3 max-w-[420px] text-[14px] leading-relaxed text-foreground-600">
                按话题快速定位你关心的爆料方向。标签热度每日统计，公开可见，不设访问门槛。
              </p>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="flex flex-wrap gap-3">
              {popularTags.map((tag, index) => (
                <a
                  key={tag.name}
                  href="#latest"
                  className={`flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2.5 text-[14px] transition-colors ${
                    index % 3 === 0
                      ? 'border-primary-200 bg-primary-50 text-primary-700 hover:bg-primary-100'
                      : index % 3 === 1
                        ? 'border-secondary-200 bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
                        : 'border-accent-300 bg-accent-50 text-accent-900 hover:bg-accent-100'
                  }`}
                >
                  {tag.name}
                  <span className="text-[12px] opacity-70">{tag.heat}</span>
                </a>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}